const KEY1 = 'get:this_user';
const KEY2 = 'set:this_user';

import {
    GET_USER_PROFILE ,
    GET_USER_PROFILE_BY_SLUG ,
} from '@/api/config'
import * as $http from '@/api/fetch'

export const state = () => {
    return {
        this_user: null,
    };
};

export const mutations = {
    [KEY1](state, val) {
        state.this_user = val;
    },
};

export const actions = {
    async [KEY1]({commit}, params = {}) {
        try {
            let API = params.user_id ? GET_USER_PROFILE : GET_USER_PROFILE_BY_SLUG

            let post_data =  params.user_id ? {user_id: params.user_id} : {url_slug: params.url_slug}

            if ($http.is_run(API)) {
                return false
            }
            let data = await $http.$axios(API, post_data)
            if (data.ec == 200) {
                commit(KEY1, data.data.user)
            }
            return data
        }
        catch (e) {
            console.log(`error in ${KEY1}`);
            console.log(e);
        }
    },
    [KEY2]({commit}, this_user = null) {
        commit(KEY1, this_user)
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
  